// URL switches for developers: ?lightdebug (tuning panel + value overrides) and ?ohmadev (keyboard tools).
// Shared by App and the mic model so both read overrides the same way.
export const urlParams = new URLSearchParams(window.location.search)
export const SHOW_LIGHT_DEBUG = urlParams.has('lightdebug')
// Developer shortcuts (keyboard tools below) only work with ?ohmadev or ?lightdebug in the link, never for customers
export const DEV_TOOLS = SHOW_LIGHT_DEBUG || urlParams.has('ohmadev')
// With ?lightdebug, starting values can be passed in the URL, e.g. &ld=overheadIntensity:4,exposure:1.2&md=cerakoteMetalness:0.1
export const debugOverrides = (param) => {
  const raw = SHOW_LIGHT_DEBUG ? urlParams.get(param) : null
  if (!raw) return {}
  return Object.fromEntries(
    raw
      .split(',')
      .map((kv) => kv.split(':'))
      .filter((a) => a.length === 2 && !isNaN(parseFloat(a[1])))
      .map(([k, v]) => [k, parseFloat(v)])
  )
}
